// extracted by mini-css-extract-plugin
module.exports = {"pageFrame":"PageFrame_pageFrame__Z5hSq"};